import { GraphQLClient } from 'graphql-request';

const request = async (mutation, queryVariables) => {
  const graphQLClient = new GraphQLClient(process.env.NEXT_PUBLIC_SANITY_GRAPHQL_SERVER_URL, {
    headers: {
      authorization: `Bearer ${process.env.NEXT_PUBLIC_SANITY_TOKEN}`
    }
  });

  return graphQLClient.request(mutation, queryVariables);
};

export default request;
